'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, version_id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      version_id: version_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/close',
        method: 'POST',
        data: {
          version_id: version_id
        }
      },
      types: ['CLOSE_EVENT_START', 'CLOSE_EVENT', 'CLOSE_EVENT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/closeEvent.js
// module id = 630
// module chunks = 0